import React from 'react';
import { FilePdfOutlined } from '@ant-design/icons';

const FilePdfIcon = () => <FilePdfOutlined style={{ fontSize: 32 }} />;

export default FilePdfIcon;
